/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_AccessInputs */

const en_common_header_ai_access = /** @type {(inputs: Common_Header_Ai_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Access`)
};

const zh_common_header_ai_access = /** @type {(inputs: Common_Header_Ai_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 接入`)
};

/**
* | output |
* | --- |
* | "AI Access" |
*
* @param {Common_Header_Ai_AccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_access = /** @type {((inputs?: Common_Header_Ai_AccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_AccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_access(inputs)
	return zh_common_header_ai_access(inputs)
});
export { common_header_ai_access as "common.header.ai_access" }